<template>
  <div class="c-report-item">
    <p class="h4">
      {{ capitalizeFirstLetter(new Date(data.date_start).toLocaleDateString('default', { month: 'long', year: 'numeric' })) }}
    </p>
    <c-report-row
      :data="data"
    />
    <div :id="`accordion-${data.id}`">
      <a
        data-toggle="collapse"
        :data-parent="`accordion-${data.id}`"
        :href="`#collapse-${data.id}`"
      >
        Файлы
      </a>
      <div
        :id="`collapse-${data.id}`"
        class="panel-collapse collapse"
      >
        <c-report-files
          :data="data.files"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CReportFiles from './CReportFiles.vue'
import CReportRow from './CReportRow.vue'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'

export default {
  name: 'CReportItem',
  components: {
    CReportFiles,
    CReportRow
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  methods: { capitalizeFirstLetter }
}
</script>

<style scoped lang="scss">
.c-report-item {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: #ddd 1px solid;
  div[id^="accordion"] {
    a {
      display: inline-block;
      margin-bottom: 5px;
    }
  }
}
</style>
